import WifiOffIcon from "@mui/icons-material/WifiOff";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export default function ServerOfflinePage({ onRetry }) {
  const handleRetry = onRetry ?? (() => window.location.reload());

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
      sx={{ color: "text.secondary", px: 2 }}
    >
      <WifiOffIcon sx={{ fontSize: 72, color: "text.disabled" }} />
      <Typography variant="h5" fontWeight={600} color="text.primary">
        Servidor indisponível
      </Typography>
      <Typography variant="body2" textAlign="center" maxWidth={360}>
        Não foi possível conectar ao servidor. Verifique a conexão ou aguarde e
        tente novamente.
      </Typography>
      <Button variant="outlined" onClick={handleRetry} sx={{ mt: 1 }}>
        Tentar novamente
      </Button>
    </Box>
  );
}
